import { FormEvent, useState } from "react";
import { supabase } from "./lib/supabase";

/** Private sign-in for existing authorized Supabase accounts. No sign-up. */
export default function PrivateLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  async function signIn(event: FormEvent) {
    event.preventDefault(); setBusy(true); setMessage("");
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setMessage(error.message);
    setBusy(false);
  }
  return <main className="auth-page"><section className="auth-panel">
    <form className="private-access-card" onSubmit={signIn}>
      <h2>Private ArcVault development login</h2>
      <p>Existing authorized accounts only.</p>
      <label>Email<input type="email" autoComplete="username" required value={email} onChange={e => setEmail(e.target.value)} /></label>
      <label>Password<input type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} /></label>
      {message && <p role="alert">{message}</p>}
      <button className="primary" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
    </form>
  </section></main>;
}
